import FlexContainer from "@agrigate/shared-web-ui/lib/FlexContainer";
import type { PropsWithChildren } from "react";
import CommonHeader from "./CommonHeader";

export default function NarrowLayout(p: PropsWithChildren<object>) {
    return (
        <FlexContainer flexProps={{ maxW: "800px", margin: "auto" }}>
            <CommonHeader />
            {p.children}
        </FlexContainer>
    );
}
